import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'

import App from 'App'
import reportWebVitals from 'reportWebVitals'
import LocalizationWrapper from 'components/LocalizationWrapper/LocalizationWrapper'
import theme from 'theme_'
import { GlobalStyle } from 'globalStyles'
import { store } from 'app/store'

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <LocalizationWrapper>
      <React.StrictMode>
        <GlobalStyle />
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>
    </LocalizationWrapper>
  </ThemeProvider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
